import { useTheme } from '@mui/material/styles';
import clsx from 'clsx';
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import styles from './Loader.module.css';

const LOADING_MESSAGES = [
  "“The Best Marketing Doesn't Feel Like Marketing.”",
  '“Nobody reads ads. People read what interests them. Sometimes, it’s an ad.” – Howard Gossage',
  '“No matter what story you tell, make your buyer the hero.” –Chris Brogan',
  '“The most powerful element in advertising is the truth.” –William Bernbach',
  '“Even when you are marketing to your entire audience or customer base, you are still simply speaking to a single human at any given time.” –Ann Handley',
  '“A brand is no longer what we tell the consumer it is—it is what consumers tell each other it is.” – Scott Cook',
  '“Marketing without data is like driving with your eyes closed.” – Dan Zarrella',
  '“Everyone is not your customer” - Seth Godin',
  '“Stopping advertising to save money is like stopping your watch to save time” - Henry Ford',
  '“If you aim at nothing, you will hit it every time.” - Zig Ziglar',
  '“I don’t care much for best practice. I care about conversions. That’s why I test.” — Michael A.',
  '“If dogs don’t like your dog food, the packaging doesn’t matter.” — Stephen Denny',
  '“If you do what you’ve always done, you’ll get what you’ve always gotten.” — Tony Robbins',
  '“If something is top of mind, it’s much more likely to be tip of tongue.” — Jonah Berger',
  '“What you say in advertising is more important than how you say it.” - David Ogilvy',
  '“Think like a wise man but communicate in the language of the people” – William Butler Yeats',
  '“If you play small, you stay small” - Jock J Davis',
];

const preventAndStop = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

function Loader({
  isAbsolute = true,
  message = '',
  showDelay = false,
  delay = 6,
  intervalDelay = 10,
  type = 'normal',
  className = '',
  fixed = false,
}) {
  const theme = useTheme();
  const [showMessage, setShowMessage] = useState(false);
  const [messageIndex, setMessageIndex] = useState(-1);
  const [mounted, setMounted] = useState(false);
  const [initialDone, setInitialDone] = useState(false);

  const visibleMessage = useMemo(() => {
    return message || LOADING_MESSAGES[messageIndex];
  }, [message, messageIndex]);

  const updateMessage = useCallback(() => {
    if (!message) {
      let index;
      do {
        index = Math.floor(Math.random() * LOADING_MESSAGES.length);
      } while (index == messageIndex);
      setMessageIndex(index);
    }
    setShowMessage(showDelay);
    setInitialDone(true);
  }, [message, messageIndex, showDelay]);

  useEffect(() => {
    setMounted(true);
    if (showDelay) {
      const timeout = setTimeout(() => updateMessage(), delay * 1000);
      return () => clearTimeout(timeout);
    }
  }, []);

  useEffect(() => {
    if (initialDone) {
      const timeout = setTimeout(() => updateMessage(), intervalDelay * 1000);
      return () => clearTimeout(timeout);
    }
  }, [intervalDelay, showDelay, updateMessage, initialDone]);

  const ballSrc = useMemo(() => {
    if (!mounted) return "/v2/images/favicon-dark.png";
    return theme.palette.mode === 'dark' ? "/v2/images/favicon-light.png" : "/v2/images/favicon-dark.png";
  }, [mounted, theme.palette.mode]);

  return (
    <div
      className={clsx(
        styles['loader-container'],
        isAbsolute && styles['loader-overlay'],
        styles[type],
        showMessage && styles['has-message'],
        className
      )}
      style={fixed ? { position: 'fixed' } : undefined}
      onClick={preventAndStop}
    >
      <div className={styles['loader']}>
        <div className={styles['shadow']}></div>
        <img
          src={ballSrc}
          className={styles['ball']}
          alt=""
        />
      </div>
      <div className={styles['message-box']} style={{ position: 'relative' }}>
        <div className={styles['message-container']}>
          {/* <transition name="slide-fade" appear=""> */}
          {showMessage && (
            <p className={styles['loading-message']}>{visibleMessage}</p>
          )}
          {/* </transition> */}
        </div>
      </div>
    </div>
  );
}

export default memo(Loader);